import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from '#components/text';
import { useIsFrontendStyleDefault, useIsFrontendStyleRed } from '#base/hooks';

const ForgotPasswordFormDescription: FC = () => {
  const isFrontendStyleDefault = useIsFrontendStyleDefault();
  const isFrontendStyleRed = useIsFrontendStyleRed();

  return (
    <Text colorGray={isFrontendStyleDefault} colorCharming={isFrontendStyleRed} fontSizeSm textAlignCenter>
      <FormattedMessage defaultMessage="To recover your password please write your username or your Email" />
    </Text>
  );
};

export { ForgotPasswordFormDescription };
